import { lazy } from "react";

export const SalesWorkspacesView = lazy(() => import("./SalesWorkspacesView"));
export const SalesCreateWorkspaceView = lazy(
  () => import("./SalesCreateWorkspaceView"),
);
export const WorkspaceDetailsView = lazy(
  () => import("./WorkspaceDetailsView"),
);

export const ConvertToPaidView = lazy(() => import("./ConvertToPaidView"));
export const SalesArchivedWorkspacesView = lazy(
  () => import("./SalesArchivedWorkspacesView"),
);
